module.exports = __webpack_public_path__ + "img/make-impact-new.0fa31aed.jpg";